import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { FaArrowLeft } from 'react-icons/fa';
import Button from '../common/Button';
import ToastContainer from '../common/ToastContainer';
import { useToast } from '../../hooks/useToast';
import SupportCaseService from '../../services/supportCaseService';
import './Ayuda.css';

const MAX_TITLE_LENGTH = 150;
const MAX_DESCRIPTION_LENGTH = 5000;

const NewSupportCase = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { toasts, removeToast, error: showError } = useToast();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [saving, setSaving] = useState(false);

  const canSubmit = title.trim() !== '' && description.trim() !== '';

  const handleSubmit = async (event) => {
    event.preventDefault();
    const token = auth.user?.access_token;
    if (!token || !canSubmit) return;

    setSaving(true);
    try {
      const result = await SupportCaseService.createCase({ title: title.trim(), description: description.trim() }, token);
      navigate(`/ayuda/casos/${result.data.id}`, {
        state: { message: 'Tu solicitud fue enviada. Te responderemos pronto.' }
      });
    } catch (err) {
      showError(err.message || 'Error al enviar la solicitud');
      setSaving(false);
    }
  };

  return (
    <div className="ayuda-page-container">
      <button type="button" className="ayuda-back-link" onClick={() => navigate('/ayuda')}>
        <FaArrowLeft />
        <span>Volver a Ayuda</span>
      </button>

      <div className="ayuda-header">
        <h1>Solicitar ayuda</h1>
        <p className="ayuda-subtitle">Cuéntanos qué necesitas y nuestro equipo de soporte te responderá</p>
      </div>

      <form className="ayuda-card ayuda-form" onSubmit={handleSubmit}>
        <div className="ayuda-field">
          <label className="ayuda-label" htmlFor="support-case-title">Asunto</label>
          <input
            id="support-case-title"
            type="text"
            className="ayuda-input"
            placeholder="Describe brevemente tu problema o pregunta"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            maxLength={MAX_TITLE_LENGTH}
            disabled={saving}
            autoFocus
          />
        </div>

        <div className="ayuda-field">
          <label className="ayuda-label" htmlFor="support-case-description">Descripción</label>
          <textarea
            id="support-case-description"
            className="ayuda-textarea"
            placeholder="Explica con detalle lo que sucede: qué estabas haciendo, qué esperabas que pasara y qué pasó"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
            maxLength={MAX_DESCRIPTION_LENGTH}
            rows={10}
            disabled={saving}
          />
          <span className="ayuda-field-hint">{description.length}/{MAX_DESCRIPTION_LENGTH}</span>
        </div>

        <div className="ayuda-actions">
          <Button variant="secondary" onClick={() => navigate('/ayuda')} disabled={saving}>
            Cancelar
          </Button>
          <Button type="submit" variant="primary" icon="fas fa-paper-plane" loading={saving} disabled={!canSubmit}>
            Enviar solicitud
          </Button>
        </div>
      </form>

      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </div>
  );
};

export default NewSupportCase;
